/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-06-14 17:52:30
 * @Description: 
 */
/**
  * 商城订单 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const returnorder = {
    // 列表
    list (params) {
        return axios.get(api + 'ordergood/list', { params: params })
    },
    detail (params) {
        return axios.get(api + 'ordergood/detail', { params: params })
    },
    //审核
    review (params) {
        return axios.post(api + 'ordergood/status', qs.stringify(params))
    },
    //新审核
    newreview (params) {
        return axios.post(api + 'ordergood/newreview', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'ordergood/remove', qs.stringify(params))
    },
}


// 导出接口
export default returnorder